module.exports = __webpack_public_path__ + "static/media/oncology-icon@3x.9f8e3c0a.png";